import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Button,
    Modal,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import { LoadingButton } from '@mui/lab';
import styles from './style';

const PartialFulfillmentModal = ({
    open,
    onClose,
    data,
    updatePartialFullfillment
}) => {
    const [fulfillmentData, setFulfillmentData] = useState([]);

    useEffect(() => {
        if (open && data?.fulfillment) {
            // Initialize fulfillment data with the incoming data
            setFulfillmentData(data.fulfillment.map(item => ({
                ...item,
                quantityToManuallyFulfill: item.quantityToManuallyFulfill || 0
            })));
        }
    }, [open, data]);

    const handleQuantityChange = (index, value) => {
        const numericValue = parseInt(value) || 0;
        const maxQuantity = fulfillmentData[index].quantity - fulfillmentData[index].quantityManuallyFulfilled;

        setFulfillmentData(prevData => {
            const newData = [...prevData];
            newData[index] = {
                ...newData[index],
                quantityToManuallyFulfill: Math.min(numericValue, maxQuantity)
            };
            return newData;
        });
    };

    const clearQuantity = (index) => {
        setFulfillmentData(prevData => {
            const newData = [...prevData];
            newData[index] = {
                ...newData[index],
                quantityToManuallyFulfill: 0
            };
            return newData;
        });
    };

    const handleSubmit = () => {
        // Prepare the payload in the required structure
        const payload = {
            partialFulfillmentData: fulfillmentData
                .filter(item => item.quantityToManuallyFulfill > 0)
                .map(item => ({
                    _id: item._id,
                    quantityToManuallyFulfill: item.quantityToManuallyFulfill
                }))
        };

        updatePartialFullfillment(payload);
        onClose();
        
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            BackdropProps={{
                style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' }
            }}
        >
            <Box sx={styles.modalContainer}>
                <IconButton sx={styles.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>

                <Box sx={styles.header}>
                    <Typography sx={styles.headerTitle}>Partial Fulfillment</Typography>
                </Box>

                <TableContainer sx={styles.tableContainer}>
                    <Table sx={{...styles.table, mt: 0}}>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ ...styles.tableHeadCell, backgroundColor: 'transparent' }}>Item Name</TableCell>
                                <TableCell align="center" sx={{ ...styles.tableHeadCell, backgroundColor: 'transparent' }}>Quantity</TableCell>
                                <TableCell align="center" sx={{ ...styles.tableHeadCell, backgroundColor: 'transparent' }}>Quantity Fulfilled</TableCell>
                                <TableCell align="center" sx={{ ...styles.tableHeadCell, backgroundColor: 'transparent' }}>Quantity to Fulfill</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {fulfillmentData?.map((item, index) => (
                                <TableRow key={item._id || index} sx={styles.tableRow}>
                                    <TableCell sx={styles.tableCell}>
                                        <Typography sx={{ fontWeight: 500 }}>
                                            {item.name || 'N/A'}
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center" sx={styles.tableCell}>
                                        <Typography variant="body2">
                                            {item.quantity || 0}
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center" sx={styles.tableCell}>
                                        <Typography variant="body2">
                                            {item.quantityManuallyFulfilled || 0}
                                        </Typography>
                                    </TableCell>

                                    <TableCell align="center" sx={styles.tableCell}>
                                        <Box sx={styles.quantityContainer}>
                                            <TextField
                                                type="number"
                                                value={item.quantityToManuallyFulfill}
                                                onChange={(e) => handleQuantityChange(index, e.target.value)}
                                                size="small"
                                                inputProps={{
                                                    min: 0,
                                                    max: (item.quantity || 0) - (item.quantityManuallyFulfilled || 0),
                                                    style: { textAlign: 'center' }
                                                }}
                                                sx={styles.quantityInput}
                                            />
                                            {item.quantityToManuallyFulfill > 0 && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => clearQuantity(index)}
                                                    sx={styles.clearButton}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box sx={styles.actions}>
                    <LoadingButton
                        sx={styles.jobButtons}
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!fulfillmentData.some(item => item.quantityToManuallyFulfill > 0)}
                    >
                        Save
                    </LoadingButton>
                </Box>
            </Box>
        </Modal>
    );
};

export default PartialFulfillmentModal;